import React, {Fragment, useContext} from "react";
// import PropTypes from 'prop-types';
import Layout from "../../components/Layout";
import EfpaLink from "../../components/EfpaLink";
import {AuthContext} from "../../contexts/AuthContext";
import Notifications from "../../components/Notifications";

const EntitiesHome = (props) => {
    const {userInfo} = useContext(AuthContext);

  return (
    <Layout>
      <div className="Home">
        <h2 className="efpa-h2 efpa-text toUppercase">
          Intranet responsables
        </h2>
        <div className="Home-content">
          <span className="efpa-subtitle m-auto">Haga click en una opción</span>

                    {/* Exámenes MIFID */}
                    {(userInfo.access_preinscriptions || userInfo.access_reubication) && (
                        <div className="Home-options" style={{'margin-bottom': '12px'}}>
                            {userInfo.access_preinscriptions && userInfo.access_reubication && (
                                <Fragment>
                                    <div class="col-sm-6" style={{'text-align': 'right'}}>
                                        <EfpaLink
                                            className="EfpaBtn btn-menu-responsibles mx-2"
                                            to="preinscripcion-de-candidatos"
                                        >
                                            Preinscripción a nuevos candidatos
                                        </EfpaLink>
                                    </div>
                                    <div className="col-sm-6">
                                        <EfpaLink className="EfpaBtn btn-menu-responsibles mx-2" to="panel-reubicacion">
                                            Panel de reubicación, bajas y resultados
                                        </EfpaLink>
                                    </div>
                                </Fragment>
                            )}

                            {userInfo.access_preinscriptions && !userInfo.access_reubication && (
                                <EfpaLink
                                    className="EfpaBtn mx-2"
                                    to="preinscripcion-de-candidatos"
                                >
                                    Preinscripción a nuevos candidatos
                                </EfpaLink>
                            )}
                            {userInfo.access_reubication && !userInfo.access_preinscriptions && (
                                <EfpaLink className="EfpaBtn mx-2" to="panel-reubicacion">
                                    Panel de reubicación, bajas y resultados
                                </EfpaLink>
                            )}
                        </div>
                    )}

                    {/* Exámenes LCCI */}
                    {(userInfo.access_preinscriptions_lcci || userInfo.access_reubication_lcci) && (
                        <div className="Home-options" style={{'margin-bottom': '12px'}}>
                            {userInfo.access_preinscriptions_lcci && userInfo.access_reubication_lcci && (
                                <Fragment>
                                    <div class="col-sm-6" style={{'text-align': 'right'}}>
                                        <EfpaLink
                                            className="EfpaBtn btn-menu-responsibles mx-2"
                                            to="preinscripcion-de-candidatos-lcci"
                                        >
                                            Preinscripción a nuevos candidatos LCCI
                                        </EfpaLink>
                                    </div>
                                    <div className="col-sm-6">
                                        <EfpaLink className="EfpaBtn btn-menu-responsibles mx-2"
                                                  to="panel-reubicacion-lcci">
                                            Panel de reubicación, bajas y resultados LCCI
                                        </EfpaLink>
                                    </div>
                                </Fragment>
                            )}

                            {userInfo.access_preinscriptions_lcci && !userInfo.access_reubication_lcci && (
                                <EfpaLink
                                    className="EfpaBtn mx-2"
                                    to="preinscripcion-de-candidatos-lcci"
                                >
                                    Preinscripción a nuevos candidatos LCCI
                                </EfpaLink>
                            )}
                            {userInfo.access_reubication_lcci && !userInfo.access_preinscriptions_lcci && (
                                <EfpaLink className="EfpaBtn mx-2" to="panel-reubicacion-lcci">
                                    Panel de reubicación, bajas y resultados LCCI
                                </EfpaLink>
                            )}
                        </div>
                    )}

                    {/* Seguimiento horas y documentación */}
                    {(userInfo.access_tracing || userInfo.access_documentation) && (
                        <div className="Home-options" style={{'margin-top': '30px'}}>
                            {userInfo.access_tracing && userInfo.access_documentation && (
                                <Fragment>
                                    <div class="col-sm-6" style={{'text-align': 'right'}}>
                                        <EfpaLink
                                            className="EfpaBtn btn-menu-responsibles blue-dark mx-2"
                                            to="/entidades/seguimiento">
                                            Seguimiento horas de formación
                                        </EfpaLink>
                                    </div>
                                    <div className="col-sm-6">
                                        <EfpaLink
                                            className="EfpaBtn btn-menu-responsibles blue-dark mx-2"
                                            to="/entidades/documentacion">
                                            Envío y recepción de documentos
                                        </EfpaLink>
                                    </div>
                                </Fragment>
                            )}

                            {userInfo.access_tracing && !userInfo.access_documentation && (
                                <EfpaLink className="EfpaBtn blue-dark mx-2" to="/entidades/seguimiento">
                                    Seguimiento horas de formación
                                </EfpaLink>
                            )}
                            {userInfo.access_documentation && !userInfo.access_tracing && (
                                <EfpaLink className="EfpaBtn blue-dark mx-2" to="/entidades/documentacion">
                                    Envío y recepción de documentos
                                </EfpaLink>
                            )}
                        </div>
                    )}

                    {/* Inscripciones Formación continua */}
                    {(userInfo.access_preinscriptions_fc_mifid || userInfo.access_preinscriptions_fc_lcci) && (
                        <div className="Home-options" style={{'margin-top': '42px'}}>
                            {userInfo.access_preinscriptions_fc_mifid && userInfo.access_preinscriptions_fc_lcci && (
                                <Fragment>
                                    <div class="col-sm-6" style={{'text-align': 'right'}}>
                                        <EfpaLink
                                            className="EfpaBtn btn-menu-responsibles orange-dark mx-2"
                                            to="preinscripcion-formacion-continua-mifid">
                                            Preinscripción a la Formación Continua MIFID
                                        </EfpaLink>
                                    </div>
                                    <div className="col-sm-6">
                                        <EfpaLink
                                            className="EfpaBtn btn-menu-responsibles orange-dark mx-2"
                                            to="preinscripcion-formacion-continua-lcci">
                                            Preinscripción a la Formación Continua LCCI
                                        </EfpaLink>
                                    </div>
                                </Fragment>
                            )}

                            {userInfo.access_preinscriptions_fc_mifid && !userInfo.access_preinscriptions_fc_lcci && (
                                <EfpaLink className="EfpaBtn orange-dark mx-2"
                                          to="preinscripcion-formacion-continua-mifid">
                                    Preinscripción Formación Continua MIFID
                                </EfpaLink>
                            )}
                            {userInfo.access_preinscriptions_fc_lcci && !userInfo.access_preinscriptions_fc_mifid && (
                                <EfpaLink className="EfpaBtn orange-dark mx-2"
                                          to="preinscripcion-formacion-continua-lcci">
                                    Preinscripción Formación Continua LCCI
                                </EfpaLink>
                            )}
                        </div>
                    )}
                    {
                        userInfo.access_preinscriptions_fc_insurance && (
                            <div className="Home-options" style={{'margin-top': '42px'}}>
                                    <Fragment>
                                        <div className="col-sm-6" style={{'text-align': 'right'}}>
                                            <EfpaLink
                                                className="EfpaBtn gray mx-2"
                                                to="preinscripcion-formacion-continua-seguros">
                                                Preinscripción a la Formación Continua SEGUROS
                                            </EfpaLink>
                                        </div>
                                    </Fragment>
                            </div>
                        )
                    }
                </div>
            </div>
            <Notifications endpoint="/alerts/intranet/home/" withModal/>
        </Layout>
    );
};

EntitiesHome.propTypes = {};

export default EntitiesHome;
